import React from 'react'

const DhsvPostEmpty = () => {
  return (
    <div className="blog-item post-empty">
      <div className="inner"></div>
    </div>
  )
}

DhsvPostEmpty.propTypes = {}

export default DhsvPostEmpty
